/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-console */
import {
  makeStyles,
  RACButton,
  RACCard,
  RACModal,
  CircularProgress,
  RACCOLOR,
  Grid,
  Typography,
} from '@rentacenter/racstrap';
import clsx from 'clsx';
import { useContext, useEffect, useRef, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { ApiErrorModal } from '../../../common/ApiError/ApiError';
import { AppRoute } from '../../../config/route-config';
import {
  CustomerInformationFooterAction,
  FULL_API_ERROR_MESSAGE,
  LETTER_TYPE,
  LOCAL_STORAGE_KEY,
  LOG_ACTIVITY_ERROR_MESSAGE,
  TAKE_COMMITMENT_ERROR_MESSAGE,
  NO_15_DAY_LETTER,
  ALL_OPTION,
  EMAIL_RECEIPTS_ERROR_MESSAGE,
  RECORD_CHECK_ERROR_MESSAGE,
  RECORD_CHECK_SUCCESS_MESSAGE,
  RECORD_CHECK_SUCCESS_MESSAGE_2,
  NO_RECORDS_FOUND_RECORD_CHECK_MESSAGE,
} from '../../../constants/constants';
import i18n from 'i18next'; // Import i18next
import { useTranslation } from 'react-i18next';
import { useCustomerDetails } from '../../../context/CustomerDetails/CustomerDetailsProvider';
import { useCustomerHeader } from '../../../context/CustomerHeader/CustomerHeaderProvider';
import {
  useFieldSheets,
  useFieldSheetsActions,
} from '../../../context/FieldSheets/FieldSheetsProvider';
import { useCustomerPaymentSummary } from '../../../context/CustomerPaymentSummary/CustomerPaymentSummaryProvider';
import {
  PastDueListCustomerDispatchStateContext,
  PastDueListCustomerStateContext,
} from '../../../context/PastDueListCustomer/PastDueListCustomerProvider';
import {
  usePrintLetter,
  usePrintLetterActions,
} from '../../../context/PrintLetter/PrintLetterProvider';
import { useUserStateContext } from '../../../context/user/user-contexts';
import { useWorkedHistoryActions } from '../../../context/WorkedHistory/WorkedHistoryProvider';
import { useCustomerDetailsActions } from '../../../context/CustomerDetails/CustomerDetailsProvider';
import { getAgreementInfo } from '../../../api/Customer';

import {
  CustomerLocationState,
  HistoryTab,
  PrintLetterDetails,
} from '../../../types/types';
import { getSelectedStore } from '../../../utils/utils';
import FieldSheet from '../../FieldSheet/FieldSheet';
import HalfwayNoticeLetter from '../../HalfwayNoticeLetter/HalfwayNoticeLetter';
import { NoPrintLetterModal } from '../../PastDueList/PastDueCustomerList/NoPrintLetterModal';
import { PrintFieldSheetModal } from '../../PastDueList/PastDueCustomerList/PrintFieldSheetModal';
import { PrintLetterModal } from '../../PastDueList/PastDueCustomerList/PrintLetterModal';
import { FieldVisitModal } from './FieldVisitModal';
import { TakeCommitmentModal } from './TakeCommitmentModal';
import { useFilters } from '../../../context/PastDueListSearchCriteria/PastDueListSearchCriteriaProvider';
import { Filter } from '../../../domain/PastDueList/Filter';
import { PastDueCustomerResponse } from '../../../domain/PastDueList/PastDueCustomerList';
import { CancelTokenSource } from 'axios';
import { getCancelTokenSource } from '../../../api/client';
import {
  getPastDueList,
  RequestCustomerRecordChk,
} from '../../../api/Customer';
import { PrimaryCorenterModal } from '../../PastDueList/PastDueCustomerList/PrimaryCorenterModal';
import { useStoreDetails } from '../../../context/Store/StoreProvider';
import {
  getCustomerInformation,
  transformRecordCheckResponse,
} from '../../../utils/getCustomerInformation';
import { ApiSuccessModal } from '../../../common/ApiSuccess/ApiSuccess';
import SecondFactor from '../History/TwoFactorPopup';
import { RecordCheckRequestModal } from '../ContactInformation/RequestRecordCheckModal';
const useStyles = makeStyles((theme: any) => ({
  footerRoot: {
    width: '100%',
    marginBottom: '0rem',
    display: 'block',
    position: 'fixed',
    bottom: '0',
    left: '0',
    zIndex: 1100,
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.typography.pxToRem(0),
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0',
  },
  cardBody: {
    flex: '0 0 auto',
    padding: '1rem 1rem',
  },
  leftButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.typography.pxToRem(4),
  },
  rightButtonsContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    gap: theme.typography.pxToRem(4),
  },
  button: {
    height: theme.typography.pxToRem(43),
  },
  masterLoader: {
    position: 'fixed',
    backgroundColor: `${RACCOLOR.WASHED_BLACK}`,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    opacity: 0.6,
    zIndex: 1050,
    textAlign: 'center',
    margin: 0,
  },
  Loader: {
    display: 'block',
    position: 'fixed',
    zIndex: 1051,
    top: '50%',
    right: '50%',
  },
}));

interface CustomerInformationFooterProps {
  disableEmailReceiptsButton: boolean;
  selectedReceiptCount: number;
  isEmailingReceipts: boolean;
  handleEmailReceipts: () => Promise<void>;
  selectedTab: HistoryTab;
}

export const CustomerInformationFooter = ({
  disableEmailReceiptsButton,
  selectedReceiptCount,
  isEmailingReceipts,
  handleEmailReceipts,
  selectedTab, // eslint-disable-next-line sonarjs/cognitive-complexity
}: CustomerInformationFooterProps) => {
  const initialCallToken = useRef<CancelTokenSource>();
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const { user } = useUserStateContext();
  const location = useLocation<CustomerLocationState>();
  const urlParams = new URLSearchParams(window.location.search);
  const originParam = urlParams.get('type');
  const customerlocation = useLocation<any>();
  const { setFilteredPastDueList } = useContext(
    PastDueListCustomerDispatchStateContext
  );
  const { pastDue } = useContext(PastDueListCustomerStateContext);
  const { customerPaymentSummary: customerPaymentSummaryResponse } =
    useCustomerPaymentSummary();
  const { setReloadWorkedHistory } = useWorkedHistoryActions();
  const { doFetchCommitmentForCustomer } = useCustomerDetailsActions();
  const [openTakeCommitmentModal, setOpenTakeCommitmentModal] =
    useState<boolean>(false);
  const [openFieldVisitModal, setOpenFieldVisitModal] =
    useState<boolean>(false);
  const [primaryCorenterModal, setPrimaryCorenterModal] =
    useState<boolean>(false);
  const [openPrimaryPrintLetterModal, setOpenPrimaryPrintLetterModal] =
    useState<boolean>(false);
  const [openCoCustomerPrintLetterModal, setOpenCoCustomerPrintLetterModal] =
    useState<boolean>(false);
  const [isPrintLetterPreview, setIsPrintLetterPreview] =
    useState<boolean>(false);
  const [isApiErrorOpen, setIsApiErrorOpen] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState('');

  const [showReturnConfirmModal, setShowReturnConfirmModal] = useState(false);
  const [returnCommitmentDate, setReturnCommitmentDate] = useState('');
  const [returnCommitmentTime, setReturnCommitmentTime] = useState('');
  const [openReturnSLA, setOpenReturnSLA] = useState<boolean>(false);

  const [isPrintFieldSheetPreview, setIsPrintFieldSheetPreview] =
    useState<boolean>(false);
  const [ifcreateFieldVisitEventSelected, setIfcreateFieldVisitEventSelected] =
    useState<boolean>(false);

  const [printFieldSheetClicked, setPrintFieldSheetClicked] =
    useState<boolean>(false);
  const [openNoPrintLetterModal, setOpenNoPrintLetterModal] =
    useState<boolean>(false);
  const [loader, setloader] = useState(false);
  const [disableRecordChkBtn, setDisableRecordChkBtn] = useState<boolean>(true);
  const [pastDueDisble, setPastDueDisble] = useState<boolean>(true);
  const [isApiSuccessOpen, setIsApiSuccessOpen] = useState(false);
  const [apiSuccessMessage, setApiSuccessMessage] = useState('');
  const [apiSubSuccessMessage, setApiSubSuccessMessage] = useState('');
  const [openSLA, setOpenSLA] = useState<boolean>(false);
  const [showRecordCheckModal, setShowRecordCheckModal] =
    useState<boolean>(false);
  const [isNoRecordsFound, setIsNoRecordsFound] = useState<boolean>(false);

  const {
    isLMDEnabled,
    maxReceiptsEmailable,
    customerRecordCheckRequestThresholdDays,
    isCustomerRecordCheckEnabled,
    enableFieldVisitStrategy,
    pastDueListApiLimit,
  } = useStoreDetails();

  const { fetchPrintLetter } = usePrintLetterActions();
  const {
    letters,
    loading: printLetterLoading,
    hasApiError: hasPrintLetterApiError,
    noLetter,
  } = usePrintLetter();

  if (!pastDue || !pastDue.length) {
    const localPastDue = localStorage.getItem(LOCAL_STORAGE_KEY.PAST_DUE_LIST);
    if (localPastDue) {
      setFilteredPastDueList(JSON.parse(localPastDue), false);
    }
  }

  const togglePrintLetterPreview = () => {
    setIsPrintLetterPreview(!isPrintLetterPreview);
  };

  const daysPastDue = Number(
    customerPaymentSummaryResponse?.pastDueSummary?.daysPastDue ?? 0
  );
  console.log('daysPastDue', daysPastDue);
  const ifLMDEnabled = () => {
    if (isLMDEnabled && ifcreateFieldVisitEventSelected) {
      history.push({
        pathname: `${AppRoute.DAP}`,
        state: {
          ...fieldVisitCreateEvent,
          source: 'customer',
        },
      });
    }
  };

  const {
    hasApiError,
    loading,
    customerDetails,
    coCustomerDetails,
    recordCheckData,
    setRecordCheckData,
    isLegalHoldProtected,
  } = useCustomerDetails();

  const { setPastDueListLoading, setReloadPastDueList } = useContext(
    PastDueListCustomerDispatchStateContext
  );
  const { isLoading } = useCustomerHeader();

  const { onFetchFieldSheets, setHasApiError: setHasFieldSheetApiError } =
    useFieldSheetsActions();
  const {
    fieldSheets,
    isLoading: isFieldSheetLoading,
    hasApiError: hasPrintFieldSheetApiError,
    fieldVisitCreateEvent,
  } = useFieldSheets();

  const disableActionButtons =
    hasApiError || loading || loader || isLegalHoldProtected;

  useEffect(() => {
    const customerDetailLoaded =
      loading !== undefined && !loading && !hasApiError;
    if (
      !showReturnConfirmModal &&
      ((location?.state?.commitmentDetails && customerDetailLoaded) ||
        (originParam == 'RECOMMIT' &&
          customerDetailLoaded &&
          customerPaymentSummaryResponse !== undefined))
    ) {
      setOpenTakeCommitmentModal(true);
    }
  }, [
    location,
    loading,
    hasApiError,
    customerPaymentSummaryResponse,
    originParam,
    showReturnConfirmModal,
  ]);

  const handleFieldVisitSaveSuccess = () => {
    setOpenFieldVisitModal(false);
    setReloadWorkedHistory(true);
  };

  const handleLetters = (letters: PrintLetterDetails | undefined) => {
    if (!letters) return;
    if (!letters.customer[0]) return;
    letters.customer[0].lang = customerDetails?.preferredLanguage;

    return letters;
  };
  const handleTakeCommitmentSave = () => {
    setOpenTakeCommitmentModal(false);
    // setReloadWorkedHistory(true);
    doFetchCommitmentForCustomer();
    if (location?.state?.commitmentDetails || originParam == 'RECOMMIT') {
      history.replace({
        pathname: `/am/customer/${customerId}`,
      });
    }
  };

  const handleReturnCommitmentSave = (
    commitDate: string,
    commitTime: string
  ) => {
    setOpenTakeCommitmentModal(false);
    setReturnCommitmentDate(commitDate);
    setReturnCommitmentTime(commitTime);
    setShowReturnConfirmModal(true);
  };

  const handleReturnConfirmYes = () => {
    setShowReturnConfirmModal(false);
    setOpenReturnSLA(true);
  };

  const handleReturnSLACompleted = async () => {
    setOpenReturnSLA(false);
    doFetchCommitmentForCustomer();
    try {
      const agmId = await determineAgreementId(customerId);
      if (agmId) {
        history.push({
          pathname: `${AppRoute.CustomerDelivery}/${customerId}/${agmId}`,
          state: {
            commitmentDate: returnCommitmentDate,
            commitmentTime: returnCommitmentTime,
          },
        });
      } else {
        if (location?.state?.commitmentDetails || originParam == 'RECOMMIT') {
          history.replace({ pathname: `/am/customer/${customerId}` });
        }
      }
    } catch {
      setApiErrorMessage(i18n.t(FULL_API_ERROR_MESSAGE));
      setIsApiErrorOpen(true);
    }
  };

  const handleReturnSLACanceled = () => {
    setOpenReturnSLA(false);
  };

  const handleReturnConfirmNo = () => {
    setShowReturnConfirmModal(false);
    doFetchCommitmentForCustomer();
    if (location?.state?.commitmentDetails || originParam == 'RECOMMIT') {
      history.replace({ pathname: `/am/customer/${customerId}` });
    }
  };

  const handleError = () => {
    setOpenFieldVisitModal(false);
    setApiErrorMessage(i18n.t(LOG_ACTIVITY_ERROR_MESSAGE));
    setIsApiErrorOpen(true);
  };

  const handleTakeCommitmentError = () => {
    setOpenTakeCommitmentModal(false);
    setApiErrorMessage(i18n.t(TAKE_COMMITMENT_ERROR_MESSAGE));
    setIsApiErrorOpen(true);
  };

  const handleEmailReceiptsError = () => {
    setApiErrorMessage(i18n.t(EMAIL_RECEIPTS_ERROR_MESSAGE));
    setIsApiErrorOpen(true);
  };

  const handleNoPrintLetterClose = () => {
    setOpenPrimaryPrintLetterModal(false);
    setOpenCoCustomerPrintLetterModal(false);
    setOpenNoPrintLetterModal(false);
  };

  const handleNoPrintLetterConfirm = () => {
    setIsPrintLetterPreview(true);
    setOpenPrimaryPrintLetterModal(false);
    setOpenCoCustomerPrintLetterModal(false);
    setOpenNoPrintLetterModal(false);
  };

  const { filter } = useFilters();

  const formatAllFields = (field: string[]) =>
    field.includes(ALL_OPTION) ? [] : field;

  const createFilterPayload = (filter: Filter) => {
    return {
      ...filter,
      storeNumber: getSelectedStore(),
      daysPastDue: formatAllFields(filter.daysPastDue),
      bestTimeToCall: formatAllFields(filter.bestTimeToCall),
      commitmentStatus: formatAllFields(filter.commitmentStatus),
      communicationType: formatAllFields(filter.communicationType),
      language: formatAllFields(filter.language),
    };
  };

  const fetchPastDueList = (resetPastDueList: boolean, offset: number) => {
    if (initialCallToken?.current) {
      initialCallToken.current?.cancel();
    }
    initialCallToken.current = getCancelTokenSource();
    setPastDueListLoading(true);
    getPastDueList(
      createFilterPayload(filter),
      offset,
      pastDueListApiLimit,
      initialCallToken.current?.token
    )
      .then((response: PastDueCustomerResponse[]) => {
        let responseToUse;
        if (response?.length) {
          responseToUse = response.map((pastDueItem) => {
            if (!pastDueItem.commitment) {
              return pastDueItem;
            }
            return {
              ...pastDueItem,
              commitment: {
                ...pastDueItem.commitment,
                commitmentStatus: pastDueItem.commitment.commitmentActualStatus,
              },
            };
          });
        }
        setFilteredPastDueList(responseToUse || [], resetPastDueList);
        setPastDueListLoading(false);
        setReloadPastDueList(false);
      })
      .catch((err) => {
        if (!err.__CANCEL__) {
          setIsApiErrorOpen(true);
          setApiErrorMessage(i18n.t(FULL_API_ERROR_MESSAGE));
          setPastDueListLoading(false);
          setReloadPastDueList(false);
        }
      });
  };

  const redirectCustomer = (action: CustomerInformationFooterAction) => {
    /* Invoke fetch past due list API call on second last customer, 
      and to append the data to local storage, resetPastDueList set to false */
    if (!pastDue) {
      return;
    }
    const customerId =
      location?.state?.customer?.customerId ||
      location?.pathname?.split('/')[3];
    // prefer using state in case of duplicate customers
    const currentCustomerIndex =
      location?.state?.customerIndex ??
      pastDue?.findIndex((item) => item.customerId === customerId);
    if (currentCustomerIndex === -1) {
      return;
    }
    if (
      currentCustomerIndex === pastDue?.length - 2 &&
      pastDue?.length % pastDueListApiLimit == 0
    ) {
      fetchPastDueList(false, pastDue && pastDue?.length);
    }
    const nextCustomerIndex =
      action === CustomerInformationFooterAction.NEXT
        ? currentCustomerIndex + 1
        : currentCustomerIndex - 1;
    if (pastDue?.[nextCustomerIndex]) {
      history.push(
        AppRoute.Customer + '/' + pastDue[nextCustomerIndex].customerId,
        {
          customer: pastDue[nextCustomerIndex],
          customerIndex: nextCustomerIndex,
        }
      );
    }
  };

  const onCoCustomerPrintLetterConfirm = async () => {
    const customerId = coCustomerDetails?.customerId;

    if (openCoCustomerPrintLetterModal && customerId && user?.id) {
      const printLetterDetailPayload = {
        storeNumber: getSelectedStore(),
        customerId: [customerId],
        coWorkerId: user?.employeeId || ' ',
        letterType: LETTER_TYPE.COL,
      };

      fetchPrintLetter(printLetterDetailPayload);
    }
  };

  const onPrimaryCustomerPrintLetterConfirm = async () => {
    const customerId = customerDetails?.customerId;

    if (openPrimaryPrintLetterModal && customerId && user?.id) {
      const printLetterDetailPayload = {
        storeNumber: getSelectedStore(),
        customerId: [customerId],
        coWorkerId: user?.employeeId || ' ',
        letterType: LETTER_TYPE.COL,
      };

      fetchPrintLetter(printLetterDetailPayload);
    }
  };

  useEffect(() => {
    if (letters && !printLetterLoading && !hasPrintLetterApiError) {
      togglePrintLetterPreview();
      setOpenPrimaryPrintLetterModal(false);
      setOpenCoCustomerPrintLetterModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [letters, printLetterLoading, hasPrintLetterApiError]);

  useEffect(() => {
    if (hasPrintLetterApiError || noLetter) {
      setOpenCoCustomerPrintLetterModal(false);
      setOpenPrimaryPrintLetterModal(false);
      setApiErrorMessage(
        noLetter ? i18n.t(NO_15_DAY_LETTER) : i18n.t(FULL_API_ERROR_MESSAGE)
      );
      setIsApiErrorOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPrintLetterApiError, noLetter]);

  const { customerFirstName, customerLastName } =
    location?.state?.customer || {};

  const fullName = `${customerDetails?.firstName || customerFirstName || ''} ${
    customerDetails?.lastName || customerLastName || ''
  }`;

  const primaryfullName = `${
    customerDetails?.firstName || customerFirstName || ''
  } ${customerDetails?.lastName || customerLastName || ''}`;

  const coCustomerfullName = `${
    coCustomerDetails?.firstName || customerFirstName || ''
  } ${coCustomerDetails?.lastName || customerLastName || ''}`;

  const openLetterForPrimary = () => {
    setPrintLetterToOpen(true);
    setPrimaryCorenterModal(false);
  };

  const openLetterForCoCustomer = () => {
    setPrintLetterToOpen(false);
    setPrimaryCorenterModal(false);
  };

  const determineIfCoCustomerIsPresent = () => {
    if (
      customerDetails?.coCustomerId ||
      (customerDetails.coCustomer === 'Y' && customerDetails.primaryCustomerId)
    ) {
      // display the modal to let the coworker pick which one he wants
      setPrimaryCorenterModal(true);
    } else {
      setPrintLetterToOpen(true);
    }
  };
  const setPrintLetterToOpen = (primary: boolean) => {
    if (primary) {
      setOpenPrimaryPrintLetterModal(true);
      setOpenCoCustomerPrintLetterModal(false);
    } else {
      setOpenCoCustomerPrintLetterModal(true);
      setOpenPrimaryPrintLetterModal(false);
    }
  };
  const togglePrintFieldSheetPreview = () => {
    setIsPrintFieldSheetPreview(!isPrintFieldSheetPreview);
  };
  const onPrintFieldSheetConfirm = (
    selectedValue: string,
    createFieldVisitEvent: boolean
  ) => {
    setIsPrintFieldSheetPreview(true);
    if (customerDetails?.customerId) {
      onFetchFieldSheets(
        selectedValue,
        [customerDetails.customerId],
        createFieldVisitEvent
      );
    }
    setIfcreateFieldVisitEventSelected(createFieldVisitEvent);
  };

  useEffect(() => {
    if (hasPrintFieldSheetApiError) {
      setIsPrintFieldSheetPreview(false);
      setPrintFieldSheetClicked(false);
      setApiErrorMessage(i18n.t(FULL_API_ERROR_MESSAGE));
      setIsApiErrorOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPrintFieldSheetApiError]);

  useEffect(() => {
    if (recordCheckData && recordCheckData.transactionDate) {
      const recordDate = new Date(recordCheckData.transactionDate);
      const currentDate = new Date();

      // Calculate the difference in days
      const diffInDays = Math.floor(
        (currentDate.getTime() - recordDate.getTime()) / (1000 * 3600 * 24)
      );
      console.log('diffInDays', diffInDays);
      setDisableRecordChkBtn(
        diffInDays <= customerRecordCheckRequestThresholdDays
      );
    }
    setPastDueDisble(daysPastDue <= 0);
  }, [recordCheckData, customerRecordCheckRequestThresholdDays, daysPastDue]);

  const isPrintFieldSheetDisplayed =
    isPrintFieldSheetPreview && fieldSheets?.length;

  const isPrintLetterDisplayed =
    isPrintLetterPreview && !noLetter && letters?.customer?.length;

  const isCustomerRedirect =
    customerlocation?.state?.redirectSource === 'customer';

  const customerId =
    location?.state?.customer?.customerId || location?.pathname?.split('/')[3];
  const customerIndex =
    location?.state?.customerIndex ??
    pastDue?.findIndex((item) => item.customerId === customerId);

  const requestRecordChk = async () => {
    try {
      setloader(true);
      const customerInfo = await getCustomerInformation(customerDetails);
      const payload = {
        customerDetails: [
          {
            customerId: customerId,
            firstName: customerInfo.firstName,
            lastName: customerInfo.lastName,
            ssn: customerInfo.ssn,
            dateOfBirth: customerInfo.dateOfBirth,
            requiredSkipTraceData: {
              phone: 'Y',
              address: 'Y',
              email: 'Y',
              employer: 'Y',
              reference: 'Y',
            },
          },
        ],
      };

      const response = await RequestCustomerRecordChk(payload);
      console.log('response', response);

      const rawData = response?.customreResponse[0];

      if (
        rawData?.error &&
        rawData?.error?.toUpperCase()?.includes('REPORTTOKEN')
      ) {
        setloader(false);
        setApiSuccessMessage(NO_RECORDS_FOUND_RECORD_CHECK_MESSAGE);
        setIsNoRecordsFound(true);
        setIsApiSuccessOpen(true);
      } else if (rawData?.transactionId) {
        const transformed = transformRecordCheckResponse(rawData);
        setRecordCheckData(transformed);
        setloader(false);
        setApiSuccessMessage(RECORD_CHECK_SUCCESS_MESSAGE);
        setApiSubSuccessMessage(RECORD_CHECK_SUCCESS_MESSAGE_2);
        setIsApiSuccessOpen(true);
      } else {
        setloader(false);
        setApiErrorMessage(RECORD_CHECK_ERROR_MESSAGE);
        setIsApiErrorOpen(true);
      }
    } catch (err) {
      setloader(false);
      console.error('Error in RequestCustomerRecordChk', err);
      setApiErrorMessage(RECORD_CHECK_ERROR_MESSAGE);
      setIsApiErrorOpen(true);
    }
  };

  const SLACanceled = () => {
    setOpenSLA(false);
  };

  const determineAgreementNumber = async (custId: any): Promise<string> => {
    if (custId) {
      const storeNumber = window.sessionStorage.getItem('storeNumber');
      const custDtl = await getAgreementInfo(custId);
      for (let idx = 0; idx < custDtl?.stores?.length; idx++) {
        for (
          let inner = 0;
          custDtl.stores[idx].agreements &&
          inner < custDtl.stores[idx].agreements?.length;
          inner++
        ) {
          if (
            storeNumber == custDtl.stores[idx].storeNumber &&
            custDtl.stores[idx].agreements[inner].agreementNumber
          )
            return custDtl.stores[idx].agreements[inner].agreementNumber;
        }
      }
    }

    return '';
  };

  const determineAgreementId = async (custId: any): Promise<string> => {
    if (custId) {
      const storeNumber = window.sessionStorage.getItem('storeNumber');
      const custDtl = await getAgreementInfo(custId);
      for (let idx = 0; idx < custDtl?.stores?.length; idx++) {
        for (
          let inner = 0;
          custDtl.stores[idx].agreements &&
          inner < custDtl.stores[idx].agreements?.length;
          inner++
        ) {
          if (
            storeNumber == custDtl.stores[idx].storeNumber &&
            custDtl.stores[idx].agreements[inner].agreementId
          )
            return custDtl.stores[idx].agreements[inner].agreementId;
        }
      }
    }

    return '';
  };

  const scheduleOrPrintFieldSheet = async () => {
    if (enableFieldVisitStrategy && customerDetails?.customerId) {
      // retrieve the agm number

      const agmNum = await determineAgreementNumber(customerDetails.customerId);
      if (agmNum) {
        const oneCustomer: any[] = [];
        oneCustomer.push({
          name: customerDetails.firstName + ' ' + customerDetails.lastName,
          source: 'customer',
          agreementNumber: agmNum,
          customerId: customerDetails.customerId,
        });
        history.push({
          pathname: `${AppRoute.DAP}`,
          state: {
            ...oneCustomer,
            source: 'customer',
          },
        });
      } else {
        setPrintFieldSheetClicked(true);
      }
    } else {
      setPrintFieldSheetClicked(true);
    }
  };

  return (
    <div className={clsx(classes.footerRoot)}>
      {showRecordCheckModal && (
        <RecordCheckRequestModal
          open={showRecordCheckModal}
          onClose={() => {
            setShowRecordCheckModal(false);
            SLACanceled();
          }}
          onSave={() => {
            setShowRecordCheckModal(false);
            requestRecordChk();
          }}
          onError={() => {
            setIsApiErrorOpen(true);
            setApiErrorMessage(RECORD_CHECK_ERROR_MESSAGE);
          }}
        />
      )}
      {openSLA === true ? (
        <SecondFactor
          setTwoFactorCancelClick={() => SLACanceled()}
          setTwoFactorCompleted={() => {
            setShowRecordCheckModal(true);
            SLACanceled();
          }}
          moduleName={'RecordCheckAccess'}
          CurrentRole={user?.role}
        />
      ) : null}
      {openReturnSLA === true ? (
        <SecondFactor
          setTwoFactorCancelClick={() => handleReturnSLACanceled()}
          setTwoFactorCompleted={() => handleReturnSLACompleted()}
          moduleName={'CustomerRetention'}
          CurrentRole={user?.role}
        />
      ) : null}
      {isApiSuccessOpen && (
        <ApiSuccessModal
          open={isApiSuccessOpen}
          message={apiSuccessMessage}
          secondmsg={apiSubSuccessMessage}
          isNoRecordsFound={isNoRecordsFound}
          onClose={() => {
            setApiSuccessMessage('');
            setApiSubSuccessMessage('');
            setIsApiSuccessOpen(false);
            setIsNoRecordsFound(false);
          }}
        />
      )}
      {loader === true ? (
        <Grid className={classes.masterLoader}>
          <Grid className={classes.Loader}>
            <CircularProgress />
          </Grid>
        </Grid>
      ) : null}
      {isApiErrorOpen && (
        <ApiErrorModal
          open={isApiErrorOpen}
          message={apiErrorMessage}
          onClose={() => {
            setApiErrorMessage('');
            setIsApiErrorOpen(false);
            setHasFieldSheetApiError(false);
          }}
        />
      )}
      {openNoPrintLetterModal && (
        <NoPrintLetterModal
          onClose={handleNoPrintLetterClose}
          onConfirm={handleNoPrintLetterConfirm}
          disableActionButtons={printLetterLoading}
        />
      )}
      {printFieldSheetClicked && (
        <PrintFieldSheetModal
          onConfirm={onPrintFieldSheetConfirm}
          onClose={setPrintFieldSheetClicked}
          customerName={fullName}
          onlyOneCustomerSelected={true}
        />
      )}
      {openTakeCommitmentModal && (
        <TakeCommitmentModal
          onSave={handleTakeCommitmentSave}
          onClose={() => {
            setOpenTakeCommitmentModal(false);
            if (
              location?.state?.commitmentDetails ||
              originParam == 'RECOMMIT'
            ) {
              history.replace({
                pathname: `/am/customer/${customerId}`,
              });
            }
          }}
          onError={handleTakeCommitmentError}
          open={openTakeCommitmentModal}
          onReturnCommitmentSave={handleReturnCommitmentSave}
        />
      )}
      {showReturnConfirmModal && (
        <RACModal
          isOpen={showReturnConfirmModal}
          maxWidth="xs"
          title=""
          content={
            <Grid
              container
              justifyContent="center"
              style={{ padding: '1rem 1.5rem' }}
            >
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <Typography
                  variant="body2"
                  style={{
                    fontFamily: 'OpenSans-bold',
                    fontSize: '1rem',
                    lineHeight: '1.5',
                  }}
                >
                  {t(
                    'Is the customer in-store and want to return the item now?'
                  )}
                </Typography>
              </Grid>
            </Grid>
          }
          onClose={() => handleReturnConfirmNo()}
          buttons={
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
                gap: '1rem',
              }}
            >
              <RACButton
                variant="outlined"
                color="secondary"
                onClick={() => handleReturnConfirmNo()}
              >
                {t('No')}
              </RACButton>
              <RACButton
                variant="contained"
                color="primary"
                onClick={() => handleReturnConfirmYes()}
              >
                {t('Yes')}
              </RACButton>
            </div>
          }
        />
      )}
      <RACCard className={classes.card}>
        <div className={clsx(classes.cardBody)}>
          <div className={clsx(classes.row)}>
            <div className={classes.leftButtonsContainer}>
              <RACButton
                variant="outlined"
                color="secondary"
                onClick={() =>
                  isCustomerRedirect
                    ? history.push(
                        `/customer/update/${customerDetails?.customerId}/customer`
                      )
                    : history.push(AppRoute.PastDueList)
                }
              >
                {t('Cancel')}
              </RACButton>
            </div>
            {openFieldVisitModal && (
              <FieldVisitModal
                onClose={setOpenFieldVisitModal}
                onSaveSuccess={handleFieldVisitSaveSuccess}
                onError={handleError}
              />
            )}
            {primaryCorenterModal && (
              <PrimaryCorenterModal
                primaryfullName={primaryfullName}
                coCustomerfullName={coCustomerfullName}
                onClose={() => setPrimaryCorenterModal(false)}
                onOpenLetterForPrimary={openLetterForPrimary}
                onOpenLetterForCoCustomer={openLetterForCoCustomer}
              />
            )}
            {openCoCustomerPrintLetterModal && (
              <PrintLetterModal
                customerName={coCustomerfullName}
                onClose={() => setOpenCoCustomerPrintLetterModal(false)}
                onConfirm={onCoCustomerPrintLetterConfirm}
                disableActionButtons={printLetterLoading}
              />
            )}
            {openPrimaryPrintLetterModal && (
              <PrintLetterModal
                customerName={primaryfullName}
                onClose={() => setOpenPrimaryPrintLetterModal(false)}
                onConfirm={onPrimaryCustomerPrintLetterConfirm}
                disableActionButtons={printLetterLoading}
              />
            )}
            {isPrintLetterDisplayed && (
              <HalfwayNoticeLetter
                onClose={() => {
                  togglePrintLetterPreview();
                  setReloadWorkedHistory(true);
                }}
                printLetterDetails={
                  handleLetters(letters) || ({} as PrintLetterDetails)
                }
              />
            )}
            {isPrintFieldSheetDisplayed && (
              <FieldSheet
                isLoading={isFieldSheetLoading}
                fieldSheets={fieldSheets}
                onSave={() => {
                  setIsPrintFieldSheetPreview(false);
                  setPrintFieldSheetClicked(false);
                  ifLMDEnabled();
                }}
                onClose={togglePrintFieldSheetPreview}
              />
            )}
            <div className={classes.rightButtonsContainer}>
              {isCustomerRecordCheckEnabled && (
                <RACButton
                  className={clsx(classes.button)}
                  variant="contained"
                  size="small"
                  color="primary"
                  key="custInfoFooterRecordCheck"
                  onClick={() => setOpenSLA(true)}
                  disabled={
                    (!!recordCheckData && disableRecordChkBtn) ||
                    disableActionButtons ||
                    pastDueDisble
                  }
                >
                  {t('Request Record Check')}
                </RACButton>
              )}
              {maxReceiptsEmailable > 0 &&
                (selectedTab === HistoryTab.Payment || isEmailingReceipts) && (
                  <RACButton
                    className={clsx(classes.button)}
                    variant="contained"
                    size="small"
                    color="primary"
                    key="custInfoFooterEmailReceipts"
                    onClick={() =>
                      handleEmailReceipts().catch(handleEmailReceiptsError)
                    }
                    disabled={
                      disableEmailReceiptsButton || disableActionButtons
                    }
                    loading={isEmailingReceipts}
                  >
                    {selectedReceiptCount === 1
                      ? t('Email Selected Receipt')
                      : t('Email Selected Receipts')}
                  </RACButton>
                )}
              <RACButton
                className={clsx(classes.button)}
                variant="contained"
                size="small"
                color="primary"
                key="custInfoFooterFieldVisit"
                onClick={() => setOpenFieldVisitModal(true)}
                disabled={disableActionButtons}
              >
                {t('Log Field Visit')}
              </RACButton>
              <RACButton
                className={clsx(classes.button)}
                variant="contained"
                size="small"
                key="custInfoFooterPrintFieldSheets"
                color="primary"
                disabled={disableActionButtons}
                onClick={async () => await scheduleOrPrintFieldSheet()}
              >
                {enableFieldVisitStrategy
                  ? t('Schedule Field Visit')
                  : t('Print Field Sheet')}
              </RACButton>
              <RACButton
                className={clsx(classes.button)}
                variant="contained"
                size="small"
                key="custInfoFooterPrintLetter"
                color="primary"
                onClick={() => determineIfCoCustomerIsPresent()}
                disabled={disableActionButtons}
              >
                {t('Print Letter')}
              </RACButton>
              <RACButton
                className={clsx(classes.button)}
                variant="contained"
                size="small"
                key="custInfoFooterTakeCommitment"
                color="primary"
                onClick={() => setOpenTakeCommitmentModal(true)}
                disabled={disableActionButtons}
              >
                {t('Take Commitment')}
              </RACButton>
              <Link
                style={{ color: 'inherit', textDecoration: 'unset' }}
                onClick={(event) => {
                  if (isLegalHoldProtected) event.preventDefault();
                }}
                to={{
                  pathname: `${AppRoute.TakePayment}/${customerDetails?.customerId}/0`,
                  state: {
                    ...(location?.state || {}),
                    redirectSource: 'am',
                    accountManagementCustomerId: customerDetails?.customerId,
                  },
                }}
              >
                <RACButton
                  className={clsx(classes.button)}
                  variant="contained"
                  size="small"
                  key="custInfoFooterTakePayment"
                  color="primary"
                  onClick={() => {
                    //noop
                  }}
                  disabled={disableActionButtons}
                >
                  {t('Take Payment')}
                </RACButton>
              </Link>

              <RACButton
                className={clsx(classes.button)}
                variant="contained"
                size="small"
                key="custInfoFooterPrevious"
                color="primary"
                disabled={
                  disableActionButtons ||
                  !customerIndex ||
                  customerIndex <= 0 ||
                  isLoading
                }
                onClick={() =>
                  redirectCustomer(CustomerInformationFooterAction.PREVIOUS)
                }
              >
                {t('Previous')}
              </RACButton>
              <RACButton
                className={clsx(classes.button)}
                variant="contained"
                size="small"
                key="custInfoFooterNext"
                color="primary"
                disabled={
                  customerIndex === -1 ||
                  (pastDue &&
                    pastDue?.length % pastDueListApiLimit !== 0 &&
                    customerIndex === pastDue?.length - 1) ||
                  isLoading ||
                  disableActionButtons
                }
                onClick={() =>
                  redirectCustomer(CustomerInformationFooterAction.NEXT)
                }
              >
                {t('Next')}
              </RACButton>
            </div>
          </div>
        </div>
      </RACCard>
    </div>
  );
};
